import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { IconField } from 'primeng/iconfield';
import { IftaLabelModule } from 'primeng/iftalabel';
import { InputIcon } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';
import { MultiSelectModule } from 'primeng/multiselect';
import { Textarea } from 'primeng/textarea';
import SampleHardwareRevisionWriteDTO
    from '../../../../../../types/sample-hardware-revision/SampleHardwareRevisionWriteDTO';
import { SampleHardwareRevisionService } from '../../../../services/sample-hardware-revision.service';

@Component({
    selector: 'app-update-sample-hardware-revision-dialog',
    imports: [
        DialogModule,
        InputTextModule,
        ButtonModule,
        FormsModule,
        IconField,
        InputIcon,
        IftaLabelModule,
        Textarea,
        MultiSelectModule,
    ],
    templateUrl: './update-sample-hardware-revision-dialog.component.html',
    styleUrl: './update-sample-hardware-revision-dialog.component.scss'
})
export class UpdateSampleHardwareRevisionDialogComponent {
    @Input() public visible: boolean = false;
    @Input() public sampleHardwareRevision: SampleHardwareRevisionWriteDTO = new SampleHardwareRevisionWriteDTO({});
    @Output() public visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() public sampleHardwareRevisionUpdated: EventEmitter<SampleHardwareRevisionWriteDTO> = new EventEmitter<SampleHardwareRevisionWriteDTO>();

    public loading = false;

    constructor(private sampleHardwareRevisionService: SampleHardwareRevisionService,
                private messageService: MessageService) {
    }

    /**
     * Enables or Disables the save button based on required fields.
     */
    get saveDisabled(): boolean {
        return !this.sampleHardwareRevision.pcbVersion || !this.sampleHardwareRevision.description;
    }

    /**
     * Closes the update dialog box and resets the status variables.
     */
    public close() {
        this.visible = false;
        this.visibleChange.emit(this.visible);
    }

    /**
     * Updates the hardware revision by sending the update request to the server.
     */
    public updateSampleHardwareRevision() {
        this.loading = true;
        this.sampleHardwareRevisionService.updateSampleHardwareRevision(this.sampleHardwareRevision).then((updated) => {
            if (!updated.hasMatchingPhysicalSamples) {
                this.messageService.add({
                    severity: 'warn',
                    summary: 'No matching sample found',
                    detail: `No physical sample currently reports PCB '${ updated.pcbVersion }' - this may be new hardware not yet seen in the field.`,
                    life: 6000
                });
            }
            this.sampleHardwareRevisionUpdated.emit(this.sampleHardwareRevision);
            this.close();
        }).catch((error) => {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: error.message, life: 3000 });
        }).finally(() => {
            this.loading = false;
        });
    }
}
